import React from 'react';
import { Button } from '../../components/ui/button.jsx';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@radix-ui/react-icons';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card.jsx';

function UnauthorizedPage() {
    return (
        <div className="min-h-full min-w-full flex flex-col justify-center items-center">
            <Card className="w-full max-w-md shadow-lg">
                <CardHeader className="text-center space-y-2">
                    <div className="w-20 h-20 mx-auto bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center">
                        <span className="text-4xl font-bold text-gray-400">404</span>
                    </div>
                    <CardTitle className="text-2xl font-bold">Access Denied</CardTitle>
                    <CardDescription className="text-gray-500 dark:text-gray-400">
                        Sorry, you don't have permission to access this page.
                    </CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col items-center space-y-4">
                    <p className="text-center text-gray-600 dark:text-gray-300">
                        Please contact your administrator if you believe this is a mistake.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
                        <Button asChild variant="default" className="flex-1">
                            <Link to="/" className="flex items-center justify-center">
                                <ArrowLeftIcon className="mr-2 h-4 w-4" />
                                Home
                            </Link>
                        </Button>
                        <Button asChild variant="outline" className="flex-1">
                            <Link to="/login" className="flex items-center justify-center">
                                Login
                            </Link>
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}

export default UnauthorizedPage;